<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<script lang="ts">
import type {
  DropdownMenuItemEmits as RekaDropdownMenuItemEmits,
  DropdownMenuItemProps as RekaDropdownMenuItemProps,
} from 'reka-ui'

import '../item.css'

export interface DropdownMenuItemProps extends RekaDropdownMenuItemProps {
  danger?: boolean
}

export type DropdownMenuItemEmits = RekaDropdownMenuItemEmits
type DropdownMenuItemSlots = {
  default(props: {}): unknown
  icon?(props: {}): unknown
  right(props: {}): unknown
}
</script>

<script setup lang="ts">
import { DropdownMenuItem as RekaDropdownMenuItem } from 'reka-ui'

import { useForwardPropsEmitsSkip } from '@/composables/utils/useForwardPropsEmitsSkip.ts'

const props = defineProps<DropdownMenuItemProps>()
const emit = defineEmits<DropdownMenuItemEmits>()
const slots = defineSlots<DropdownMenuItemSlots>()
const forwarded = useForwardPropsEmitsSkip(props, emit, ['danger'])
</script>

<template>
  <RekaDropdownMenuItem v-bind="forwarded" class="flopui-menu-item" :class="{ danger }">
    <div v-if="slots.icon" class="flopui-menu-item-icon" aria-hidden="true">
      <slot name="icon" />
    </div>
    <div class="flopui-menu-item-contents">
      <slot />
    </div>
    <div class="flopui-menu-item-right">
      <slot name="right" />
    </div>
  </RekaDropdownMenuItem>
</template>
